<template>
    <div>
        <div class="greybox theme-border-left-5">
            <div class="row">
                <div class="col-md text-center">
                    <span class="theme-text-color-primary theme-header">Make a claim</span>
                </div>
                <div class="col-md text-center border-left border-right">
                    <p>Please ensure that you have your Policy number and the full circumstances as we
                    will require it to process your insurance claim.</p>
                    <p>Also you will have the opportunity
                    to upload supporting documents including proof of purchase and pictures of the damage
                    which will help us process your insurance claim.</p>
                </div>
                <div class="col-md text-center">
                    <button class="button" @click="() => { $router.push({ path: 'makeaclaim' }) }">Let's go</button>
                </div>
            </div>
        </div>
        <div class="greybox theme-border-left-5 mt-3">
            <div class="row">
                <div class="col-md text-center">
                    <span class="theme-text-color-primary theme-header">Resume a claim</span>
                </div>
                <div class="col-md text-center border-left border-right">
                    <p>If you have already started a claim and clicked "Save for later" you can retrieve
                    the details and complete the claim.</p>
                    <p v-if="!isTiga">You will be asked to logon with the details that we will have sent you via email.</p>
                </div>
                <div class="col-md text-center">
                    <button class="button" @click="() => { $router.push({ path: resumeLink }) }">Let's go</button>
                </div>
            </div>
        </div>
        <div class="greybox theme-border-left-5 mt-3">
            <div class="row">
                <div class="col-md text-center">
                    <span class="theme-text-color-primary theme-header">Check status of a claim</span>
                </div>
                <div class="col-md text-center border-left border-right">
                    <p>If you have already submitted a claim you can check on the status.</p>
                    <p>You will be asked to logon with the details that we will have sent you via email.</p>
                </div>
                <div class="col-md text-center">
                    <button class="button" @click="() => { $router.push({ path: 'myclaims' }) }">Let's go</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import taskList from '@/components/TaskList.vue'

export default {
  name: 'home',
  components: {
    taskList
  },
  mounted() {
    //console.log(this.$textManager);
  },
  computed: {
      ...mapGetters({
          getReseller: 'reseller/getResellerInfo',
      }),
      leadImageExt() {
        if (this.getReseller.leadImageExt)
            return this.getReseller.leadImageExt
        else
          return `jpg`
      },
      leadImage () {
        if (this.getReseller.leadImage)
            return this.getReseller.leadImage
        else
            return 'gadgets'
      },
      isTiga() {
        return process.env.VUE_APP_FORM_TYPE == 'tiga';
      },
      resumeLink () {
        if (this.isTiga) {
            return '/makeaclaim/resume'
        } else {
            return '/myclaims/inprogress'
        }
      }
  }
}
</script>